module.exports = __webpack_public_path__ + "1f123176c4f5a80c293423206b8e88ea.svg";